import {Grid, PlaceholderTiles} from '@aboutyou/ui-components';
import React from 'react';

export const ProductStreamSkeleton: React.FC = () => {
  return (
    <section>
      <Grid>
        <PlaceholderTiles amount={8} />
      </Grid>
    </section>
  );
};
